import { compressImageFile } from "@/core/media";

export const WELLNESS_UPLOAD_MAX_DIMENSION = 1024;
export const WELLNESS_UPLOAD_JPEG_QUALITY = 0.85;

const WELLNESS_EDITOR_MAX_DIMENSION = WELLNESS_UPLOAD_MAX_DIMENSION * 2;
const WELLNESS_EDITOR_QUALITY = 0.92;

export function normalizeWellnessImageForUpload(file: File): Promise<File> {
  return compressImageFile(file, WELLNESS_UPLOAD_MAX_DIMENSION, WELLNESS_UPLOAD_JPEG_QUALITY);
}

/**
 * Decode and downscale the raw file to a JPEG suitable for the Pintura editor.
 * Converts HEIC/HEIF into universally supported JPEG and caps dimensions so
 * multi-megapixel phone photos don't exhaust the mobile browser memory budget.
 * The output is 2× the final upload dimension so there is plenty of resolution
 * for cropping.
 */
export function normalizeWellnessImageForEditor(file: File): Promise<File> {
  return compressImageFile(file, WELLNESS_EDITOR_MAX_DIMENSION, WELLNESS_EDITOR_QUALITY);
}
